import Image from "next/image";
import { useState } from "react";
import styled from "styled-components";
import {
  Container,
  ContainerContentStandard,
} from "../../../../shared/styles/container";
import { device } from "../../../../shared/styles/device";
import {
  TablistContainer,
  TablistWrapper,
  Tabnav,
  TabnavItems,
} from "../../../../shared/styles/tablist/tablist";

const NarrowContentWrapper = styled.div`
  max-width: 980px;
  margin: auto;

  .text-content {
    max-width: 768px;
    margin: auto;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 350px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 32px;

  @media ${device.tablet} {
    height: 550px;
  }
  img {
    border-radius: 16px;
  }
`;

const SpeedRecruitingContent = () => {
  return (
    <NarrowContentWrapper>
      <ImageWrapper>
        <Image
          src="/images/aboutus/_Ueber_uns_Speed-Recruitings.jpg"
          alt="Speed Recruiting Image"
          layout="fill"
          objectFit="cover"
          quality={100}
        />
      </ImageWrapper>
      <div className="text-content">
        <p>
          Seit 2012 organisieren wir in ganz Deutschland
          Speed-Recruiting-Events. Dabei kommen in der Regel etwa 10 Unternehmen
          und 30 Bewerber*innen zusammen. Die Events finden zwei Mal im Jahr
          statt, jeweils im Winter und Sommer. Unser Speed-Recruiting hat
          mehrere Vorteile. Zum einen sparen teilnehmende Talente und
          Unternehmen unfassbar viel Zeit. Zum anderen sind diese Events sehr
          gute Netzwerkevents, die einen regelrechten Karriere-Boost für die
          Teilnehmer*innen mit sich bringen.
        </p>
      </div>
    </NarrowContentWrapper>
  );
};
const TalentpoolContent = () => {
  return (
    <NarrowContentWrapper>
      <ImageWrapper>
        <Image
          src="/images/aboutus/_Ueber_uns_Talentpool.jpg"
          alt="Speed Recruiting Image"
          layout="fill"
          objectFit="contain"
          quality={100}
        />
      </ImageWrapper>
      <div className="text-content">
        <p>
          Ende 2021 haben wir unseren Talentpool gelauncht. In dem digitalen
          Produkt sammeln wir talentierte Bewerber*innen, die sich für
          Marketing, Public Relations und Unternehmenskommunikation begeistern.
          Unternehmen können einen kostenpflichtigen Zugang zum Talentpool
          erwerben und passende Kandidat*innen danach direkt kontaktieren.
          Vermittlungsgebühren fallen nicht an.
        </p>
      </div>
    </NarrowContentWrapper>
  );
};
const EducationContent = () => {
  return (
    <NarrowContentWrapper>
      <ImageWrapper>
        <Image
          src="/images/aboutus/_Ueber_uns_Education.jpg"
          alt="Speed Recruiting Image"
          layout="fill"
          objectFit="cover"
          quality={100}
        />
      </ImageWrapper>
      <div className="text-content">
        <p>
          Organisiert und durchgeführt wird das STELL-MICH-EIN von der{" "}
          <a
            href={"https://scmonline.de/"}
            target="_blank"
            rel="nofollow noopener noreferrer"
          >
            SCM – School for Communication and Management
          </a>
          . Als Weiterbilderin in interner und externer Kommunikation, PR und
          Online-Kommunikation ist die SCM in ganz Deutschland und Österreich
          bekannt. Zunehmend bearbeiten wir auch HR- und Recruiting-Themen. Hast
          du Interesse an einer Partnerschaft, dann sprich uns gerne an.
        </p>
      </div>
    </NarrowContentWrapper>
  );
};
const KooperationenContent = () => {
  return (
    <NarrowContentWrapper>
      <ImageWrapper>
        <Image
          src="/images/aboutus/_Ueber_uns_Kooperationen.jpg"
          alt="Speed Recruiting Image"
          layout="fill"
          objectFit="cover"
          quality={100}
        />
      </ImageWrapper>
      <div className="text-content">
        <p>
          Unsere STELL-MICH-EIN-Events waren bereits zu Gast auf ADC-Kongressen,
          Messen und Konferenzen. Im Mai 2022 findet beispielsweise eine
          Design-Edition auf der{" "}
          <a
            href={"https://www.mcbw.de/"}
            target="_blank"
            rel="nofollow noopener noreferrer"
          >
            MCBW
          </a>
          , der Munich Creative Business Week, statt. Hast du Interesse an einer
          Kooperation, dann schreib uns gerne eine E-Mail.
        </p>
      </div>
    </NarrowContentWrapper>
  );
};
const KarrieretippsContent = () => {
  return (
    <NarrowContentWrapper>
      <ImageWrapper>
        <Image
          src="/images/aboutus/_Ueber_uns_JobNewsletter.jpg"
          alt="Speed Recruiting Image"
          layout="fill"
          objectFit="cover"
          quality={100}
        />
      </ImageWrapper>
      <div className="text-content">
        <p>
          In regelmäßigen Abständen versenden wir einen Job-Newsletter. In
          diesem Newsletter verweisen wir auf diverse offene Stellen in der
          Kommunikationsbranche. Hier auf unserer Seite kannst du dich in den
          Newsletter eintragen. Möchtest du eine Stellenanzeige dort inserieren,
          dann melde dich gerne mit einer E-Mail bei uns.
        </p>
      </div>
    </NarrowContentWrapper>
  );
};

const AboutUsNodes = [
  {
    tabname: "Speed-Recruitings",
    contents: <SpeedRecruitingContent />,
  },
  {
    tabname: "Talentpool",
    contents: <TalentpoolContent />,
  },
  {
    tabname: "Education",
    contents: <EducationContent />,
  },
  {
    tabname: "Kooperationen",
    contents: <KooperationenContent />,
  },
  {
    tabname: "Job-Newsletter",
    contents: <KarrieretippsContent />,
  },
];

export const TopicsTablist = () => {
  const [currentSelectedIndex, setCurrentSelectedIndex] = useState(0);
  const [topicBySelectedEvent, setTopics] = useState<any>(
    AboutUsNodes[0]?.contents
  );

  return (
    <section>
      <TablistContainer>
        <h2>Recruiting-Lösungen</h2>
        <p>Klick auf den jeweiligen Tab, um mehr zu erfahren.</p>
        <TablistWrapper>
          <Tabnav>
            <TabnavItems id="tablist-container" role="tablist">
              {AboutUsNodes?.map((node, index) => {
                return (
                  <li key={node.tabname} role="presentation">
                    <a
                      id={`${node.tabname}-tabnav-trigger`}
                      href={`#event-item-${node.tabname}`}
                      className={`${
                        currentSelectedIndex === index ? "current " : ""
                      }`}
                      role="tab"
                      tabIndex={currentSelectedIndex === index ? 0 : -1}
                      aria-selected={
                        currentSelectedIndex === index ? "true" : "false"
                      }
                      onClick={(event) => {
                        event.preventDefault();
                        setCurrentSelectedIndex(index);
                        setTopics(node.contents);
                        /*                                                 centerOnMobile(`${smeEvent.city}-tabnav-trigger`); */
                      }}
                    >
                      {node.tabname}
                    </a>
                  </li>
                );
              })}
            </TabnavItems>
          </Tabnav>
          <Container>
            <ContainerContentStandard>
              {topicBySelectedEvent}
            </ContainerContentStandard>
          </Container>
        </TablistWrapper>
      </TablistContainer>
    </section>
  );
};
